import axiosInsAcademy from '@/api/axios-ugems-academy'

// Get all role competencies with pagination
export const GET_ROLE_COMPETENCIES = (args) => {
    return axiosInsAcademy.get(`/role-competency${args ? `?${args}` : ''}`)
}

// Get role competency by ID
export const GET_ROLE_COMPETENCY_BY_ID = (id) => {
    return axiosInsAcademy.get(`/role-competency/${id}`)
}

// Create new role competency
export const CREATE_ROLE_COMPETENCY = (data) => {
    return axiosInsAcademy.post('/role-competency', data)
}

// Update role competency
export const UPDATE_ROLE_COMPETENCY = (id, data) => {
    return axiosInsAcademy.put(`/role-competency/${id}`, data)
}

// Delete role competency
export const DELETE_ROLE_COMPETENCY = (id) => {
    return axiosInsAcademy.delete(`/role-competency/${id}`)
}